import { ModaliteReunion } from './modaliteReunion';
import { Prestation } from './prestation';
import { TypeEntretien } from './typeEntretien';

export class SuiviPrestation {
	id: number;
	description: string;
	dateEntretien: string;
	dateProchainEntretien: string;
	typeEntretien: TypeEntretien;
	prestation: Prestation;
	modaliteReunion: ModaliteReunion;

	constructor(
		options: {
			id?: number;
			description?: string;
			dateEntretien?: string;
			dateProchainEntretien?: string;
			typeEntretien?: TypeEntretien;
			prestation?: Prestation;
			modaliteReunion?: ModaliteReunion;
		} = {}
	) {
		this.id = options.id || null;
		this.description = options.description || null;
		this.dateEntretien = options.dateEntretien || null;
		this.dateProchainEntretien = options.dateProchainEntretien || null;
		this.typeEntretien = options.typeEntretien || new TypeEntretien();
		this.prestation = options.prestation || new Prestation();
		this.modaliteReunion = options.modaliteReunion || new ModaliteReunion();
	}
}
